import ReactComponent from '../app/ReactComponent'
import {Button, Col, Flex, Image, Row} from 'antd'
import {$t} from '../app'
import onYourOwnIcon from '../gfx/iceland-on-your-own-ico.png'
import {Link, useParams} from 'react-router-dom'
import GParallax from '../components/helpers/GParallax'

// IMAGES
import droneLandscapeImage from '../gfx/DJI_01652@small.jpg'
import {$language} from '../app/Languages'

export default class PageDetailPage extends ReactComponent {
  state = {
    data: {
      id: null,
      name: null,
      content: null,
      featured_image: null,
      category: null
    }
  }

  componentDidMount() {
    const {slug = null, slug_post = null} = this.props

    this.scrollToTop()
    this.$app.$theme("light")

    void this.getPageBySlug(slug_post)
  }

  async getPageBySlug(slug) {
    const active_lang = $language().$language()

    const resFindId = await this.$app.$directus('posts', {
      fields: ['id'],
      filter: {
        translations: {
          slug: {'_eq': slug}
        }
      },
      deep: {
        translations: {
          _filter: {
            languages_code: {'_eq': active_lang},
          }
        }
      }
    })

    console.log(slug, resFindId)

    const id = resFindId.length === 1 ? resFindId[0].id : null

    const data = await this.$app.$directus(`posts/${id}`, {
      fields: ['*', {translations: ['name', 'content']}, {featured_image: ['*']}],
      deep: {
        translations: {
          _filter: {
            languages_code: {'_eq': active_lang}
          }
        }
      }
    })

    console.log(data)
    await this.updateState({
      data: {
        id: data.id,
        name: data.translations[0].name,
        content: data.translations[0].content,
        featured_image: data.featured_image,
        category: data.category
      }
    })
  }

  render() {
    return (
      <>
        <div className="silencer normal"></div>

        <section className="wide centered">
          <div className="container fullwidth centered wide post-header">
            <GParallax speed={-3} options={{y: 0}} scrollTrigger={{start: 'top top'}} className="fullwidth-background">
              <Image src={this.state.data.featured_image && `https://admin.trailsoficeandfire.com/assets/${this.state.data.featured_image.id}?quality=30`} preview={false} />
            </GParallax>



            <Row align="bottom" justify="end" style={{minHeight: 'inherit',maxWidth: '768px'}} className="container centered">
              <Col span={24}>
                <h2 className="mb-4">
                  {this.state.data.name}
                </h2>
              </Col>
            </Row>
          </div>
        </section>

        <Flex justify="center">
          <section className="container centered mt-4">
            <div className="formatted">
              <div dangerouslySetInnerHTML={{__html: this.state.data.content}}></div>
            </div>
          </section>
        </Flex>

        <div className="silencer medium"></div>

      </>
    )
  }
}

export function PageDetailPageHOC() {
  const {slug, slug_post} = useParams()

  return (<PageDetailPage slug={slug} slug_post={slug_post}/>)
}